import { render, staticRenderFns } from "./CategoryOption.vue?vue&type=template&id=5c0b682e&"
import script from "./CategoryOption.vue?vue&type=script&lang=js&"
export * from "./CategoryOption.vue?vue&type=script&lang=js&"
import style0 from "./CategoryOption.vue?vue&type=style&index=0&id=5c0b682e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports